import { render } from "./ManagerViewElections.vue?vue&type=template&id=12dda63a"
import script from "./ManagerViewElections.vue?vue&type=script&lang=js"
export * from "./ManagerViewElections.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__